import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const LoadingIcon = styled.span`
  @keyframes loadingRotate {
    0% {
      transform: rotate(0);
    }
    25% {
      transform: rotate(90deg);
    }
    50% {
      transform: rotate(180deg);
    }
    75% {
      transform: rotate(270deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  transform: translateZ(0);
  ${mixin.flex({})};
  overflow: hidden;
  width: 24px;
  height: 24px;
  transition: opacity 0.3s;

  svg {
    transform-origin: center;
    animation: loadingRotate 1s 0.1s linear infinite;
  }
`;
